import { produce } from "immer";

const EMPTY_RESPONSE = produce({
  resourceType: "QuestionnaireResponse",
  questionnaire: { reference: null },
  status: "in-progress",
  subject: { reference: null },
  authored: null,
  item: []
}, () => {})

export function toQuestionnaireResponse(answers, {
  questionnaire,
  subject,
  authored,
  status
} = {}) {
  return produce(EMPTY_RESPONSE, draft => {
    draft.questionnaire.reference = questionnaire
    draft.subject.reference = subject
    draft.authored = authored
    draft.status = status || draft.status
    draft.item = toItem(answers)
  })
}

export function toAnswerMap(itemArray) {
  return produce({}, draft => {
    (itemArray || []).forEach(item => {
      // it's either an answer
      if (item.answer?.length && isValidAnswer(item.answer[0])) {
        draft[item.linkId] = item.answer[0]

        // or a group of them
      } else if (item.item?.length) {
        const answerMap = toAnswerMap(item.item)
        if (Object.keys(answerMap).length) draft[item.linkId] = answerMap
      }
    })
  })
}

export function isValidAnswer(answer) {
  return (
    typeof answer?.valueDecimal === "number" ||
    typeof answer?.valueBoolean === "boolean"
  )
}

function toItem(answers) {
  return Object.keys(answers).map(linkId => (isValidAnswer(answers[linkId]))
    ? { linkId, answer: [answers[linkId]] }
    : { linkId, item: toItem(answers[linkId]) })
}